import PropTypes from 'prop-types'
import { Box, Text, VStack } from '@chakra-ui/react'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { colors } from '../../utils/theme/styles'

export default function RequestOk({ title, customColor }) {
  return (
    <Box>
      <VStack>
        <FontAwesomeIcon
          color={customColor ? customColor : colors.primary.base}
          icon={faCircleCheck}
          size="8x"
        />
        <Text textAlign="center">{title}</Text>
      </VStack>
    </Box>
  )
}

RequestOk.propTypes = {
  customColor: PropTypes.string,
  title: PropTypes.string,
}
